import React from "react";
import { Box, Divider, Typography } from "@mui/material";

const FormSection = ({ title, subtitle, children }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {(title || subtitle) && (
        <Box>
          {title && (
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          )}
          <Divider sx={{ mt: 1 }} />
        </Box>
      )}
      {children}
    </Box>
  );
};

export default FormSection;
